import React, { useState } from 'react';
import { Button, styled, TextField } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import BooleanCellRenderer from 'ui/AgGridReact/CellRenderers/BooleanCellRenderer';
import Flex from 'ui/Flex/Flex';
import { useGenerateApiKey, useGetApiKeyInfos } from '../hooks/generateApiKey';
import CopyButtonAdornment from 'components/SharedItemUI/CopyButtonAdornment';
import { useTranslation } from 'react-i18next';
import Loading from 'components/Loading';
import { useGetColumnDefs } from './colDef';

const StyAgContainer = styled('div', {
    name: 'StyAgContainer',
    shouldForwardProp: (prop) => prop !== 'nbRows',
})<{ nbRows: number }>(({ nbRows }) => ({
    height: `${55 + nbRows * 50}px`,
    width: '650px',
    minHeight: '150px',
    marginBottom: '1rem',
}));

const ApiKeyForm = ({ bind }: { bind: string }) => {
    const { t } = useTranslation();
    const [apiKey, setApiKey] = useState<string | null>(null);
    const { mutate: generateApiKey } = useGenerateApiKey(bind, setApiKey);
    const { data: apiKeysInfos = [], isLoading } = useGetApiKeyInfos(bind);
    const colDefs = useGetColumnDefs();

    const hasValidApiKey = apiKeysInfos.some(
        (apiKeyInfo) => apiKeyInfo.isValid,
    );

    const onApiKeyButtonClick = () => {
        generateApiKey();
    };
    if (isLoading) return <Loading></Loading>;
    return (
        <Flex margin="10px" direction="column">
            {apiKeysInfos.length > 0 && (
                <StyAgContainer
                    className="ag-theme-material"
                    nbRows={apiKeysInfos.length}
                >
                    <AgGridReact
                        rowData={apiKeysInfos}
                        columnDefs={colDefs}
                        headerHeight={50}
                        rowHeight={50}
                        components={{
                            booleanCellRenderer: BooleanCellRenderer,
                        }}
                        columnMenu="legacy"
                    />
                </StyAgContainer>
            )}
            {!hasValidApiKey && (
                <Button
                    sx={{ m: 1, height: '1rem', width: '300px' }}
                    variant="outlined"
                    color="primary"
                    onClick={onApiKeyButtonClick}
                >
                    {t('support.clientConfiguration.apiKey.button')}
                </Button>
            )}
            {apiKey && (
                <TextField
                    id="apiKey"
                    label={t('support.clientConfiguration.apiKey.title')}
                    value={apiKey}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    helperText={t('support.clientConfiguration.apiKey.help')}
                    fullWidth
                    margin="normal"
                    InputProps={{
                        startAdornment: (
                            <CopyButtonAdornment inputId="apiKey" />
                        ),
                    }}
                />
            )}
        </Flex>
    );
};
export default ApiKeyForm;
